import styled from "styled-components";
import { borders, colors, composeEnhancers, display, flexbox, position, shadows, sizes, spacing, text } from "../core/enhancers";
var composedEnhancers = composeEnhancers(position, display, colors, borders, flexbox, sizes, spacing, text, shadows);
var Box = styled.div.withConfig({
  displayName: "Box",
  componentId: "sc-7ax6ia-0"
})(["box-sizing:border-box;", ""], composedEnhancers);
export default Box;